<template>
  <div>
    <div class="d-flex mt-2">
      <feather-icon
        icon="MapPinIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        Endereço
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-row class="mt-1">
      <!-- Field: Address Line 1 -->
      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <b-form-group
          label="CEP"
          label-for="cep_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="cep_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <cleave
              id="cep_cliente_endereco"
              v-model="clienteData.cep_cliente_endereco"
              class="form-control"
              :raw="false"
              :options="optionsMask.cep"
              placeholder="0000-000"
              autocomplete="postal_code"
              :class="{'border-danger': errors.length > 0}"
            />

            <small class="text-danger">{{ errors[0] ? 'CEP é obrigatória' : '' }}</small>
          </validation-provider>

        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="">
      <!-- Field: Address Line 2 -->
      <b-col
        cols="12"
        md="6"
        lg="8"
      >
        <b-form-group
          label="Endereço"
          label-for="endereco_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="endereco_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <b-form-input
              id="endereco_cliente_endereco"
              v-model="clienteData.endereco_cliente_endereco"
              :state="errors.length > 0 ? false:null"
              autocomplete="address"
              placeholder="Ex.: Rua, Avenida, Travessa, etc."
            />
            <small class="text-danger">{{ errors[0] ? 'Endereço é obrigatória' : '' }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- Field: Postcode -->
      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <b-form-group
          label="Numéro"
          label-for="numero_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="numero_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <b-form-input
              id="numero_cliente_endereco"
              v-model="clienteData.numero_cliente_endereco"
              type="number"
              name="numero_cliente_endereco"
              placeholder="Ex.: 1234"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] ? 'Numéro é obrigatória' : '' }}</small>
          </validation-provider>

        </b-form-group>
      </b-col>

      <!-- Field: City -->
      <b-col
        cols="12"
        md="10"
        lg="10"
      >
        <b-form-group
          label="Complemento"
          label-for="complemento_cliente_endereco"
        >
          <b-form-input
            id="complemento_cliente_endereco"
            v-model="clienteData.complemento_cliente_endereco"
            placeholder="Ex.: Casa, Apartamento, etc."
          />

        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="2"
        lg="2"
      >
        <b-form-group
          label="Inscrição Estadual"
          label-for="inscricao_estadual_cliente_endereco"
        >
          <cleave
            id="inscricao_estadual_cliente_endereco"
            v-model="clienteData.inscricao_estadual_cliente_endereco"
            autocomplete="address-line-2"
            placeholder="Ex.: 123456789"
            class="form-control"
            :raw="false"
            :options="optionsMask.inscricaoEstadual"
          />

        </b-form-group>
      </b-col>

      <!-- Field: State -->
      <b-col
        cols="12"
        md="6"
        lg="5"
      >
        <b-form-group
          label="Bairro"
          label-for="bairro_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="bairro_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <b-form-input
              id="bairro_cliente_endereco"
              v-model="clienteData.bairro_cliente_endereco"
              :state="errors.length > 0 ? false:null"
              autocomplete="off"
              placeholder="Ex.: Centro, Jardim, etc."
            />
            <small class="text-danger">{{ errors[0] ? 'Bairro é obrigatória' : '' }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="5"
      >
        <b-form-group
          label="Cidade"
          label-for="cidade_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="cidade_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <v-select
              v-model="clienteData.cidade_cliente_endereco"
              :class="{ 'border-danger border-rounded': errors.length > 0 }"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="cidadeOptions"
              :reduce="val => val.id"
              label="cidade_nome"
              :state="errors.length > 0 ? false:null"
              clearable
              input-id="cidade_cliente_endereco"
              placeholder="Ex.: São Paulo, Rio de Janeiro, etc."
              @search="$emit('onCidadeChange', $event)"
            />
            <small class="text-danger">{{ errors[0] ? 'Cidade é obrigatória' : '' }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="2"
      >
        <b-form-group
          label="UF"
          label-for="uf_id_cliente_endereco"
        >
          <validation-provider
            #default="{ errors }"
            name="uf_id_cliente_endereco"
            :rules="isValidate ? 'required' : ''"
          >
            <v-select
              v-model="clienteData.uf_id_cliente_endereco"
              :class="{ 'border-danger border-rounded': errors.length > 0 }"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="ufOptions"
              :reduce="val => val.id"
              label="uf_id"
              clearable
              placeholder="Ex.: SP, RJ, etc."
              input-id="uf_id_cliente_endereco"
              @search="$emit('onUfsChange', $event)"
            />
            <small class="text-danger">{{ errors[0] ? 'UF é obrigatória' : '' }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import useOptionsMask from '@/composables/useOptionsMask'

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    Cleave,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    address: {
      type: Object,
      default: () => ({}),
    },
    ufOptions: {
      type: Array,
      default: () => ([]),
    },
    cidadeOptions: {
      type: Array,
      default: () => ([]),
    },
    isValidate: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { optionsMask } = useOptionsMask()

    return {
      optionsMask,
    }
  },
  computed: {
    clienteData: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style scoped lang="scss">

</style>
